import React from "react";
import { portfolio } from "@/data/portfolio";
import useReveal from "@/hooks/useReveal";

const Stars = ({ n = 0 }) => {
  const total = 10;
  return (
    <span className="font-mono text-[0.78rem] tracking-microcap" aria-label={`${n} of ${total}`}>
      {Array.from({ length: total }).map((_, i) => (
        <span key={i} style={{ color: i < n ? "var(--accent)" : "var(--rule)" }}>
          {i < n ? "★" : "☆"}
        </span>
      ))}
    </span>
  );
};

const Group = ({ group, idx }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`toolkit-group-${idx}`}
      className="reveal-up hairline-b py-10 md:py-12"
      style={{ borderColor: "var(--rule)" }}
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start">
        <div className="md:col-span-2 font-mono text-[0.72rem] uppercase tracking-microcap" style={{ color: "var(--ink-muted)" }}>
          <span style={{ color: "var(--ink)" }}>{group.code}</span>
        </div>
        <div className="md:col-span-4">
          <h3 className="font-serif text-3xl md:text-4xl tracking-tightest leading-[1.02]">
            {group.title}
          </h3>
          <div className="mt-3"><Stars n={group.stars} /></div>
        </div>
        <div className="md:col-span-6">
          <ul className="flex flex-wrap gap-x-3 gap-y-2">
            {group.items.map((it, i) => (
              <li
                key={i}
                className="font-mono text-[0.78rem] uppercase tracking-microcap"
                style={{ color: "var(--ink-2)" }}
              >
                {it}
                {i < group.items.length - 1 && <span className="ml-3 opacity-50">·</span>}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const Toolkit = () => {
  const refHead = useReveal();
  const { toolkit } = portfolio;
  return (
    <section
      id="toolkit"
      data-testid="toolkit-section"
      className="px-5 md:px-10 py-14 md:py-28"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="flex items-baseline justify-between mb-6 md:mb-10">
          <div className="section-tag">
            <span style={{ color: "var(--ink)" }}>{toolkit.section}</span>
            <span className="ml-3">{toolkit.eyebrow}</span>
          </div>
          <div className="section-tag">→ T.01 — T.06</div>
        </div>

        <h2 ref={refHead} className="reveal-up display text-4xl sm:text-5xl md:text-7xl lg:text-8xl max-w-[18ch]">
          The stack <span className="display-italic" style={{ color: "var(--accent)" }}>under the hood.</span>
        </h2>
        <p className="font-serif text-base sm:text-lg md:text-xl max-w-[55ch] mt-6 md:mt-8 mb-8 md:mb-14" style={{ color: "var(--ink-2)" }}>
          {toolkit.intro}
        </p>

        <div className="hairline-b" style={{ borderColor: "var(--rule)" }}>
          {toolkit.groups.map((g, i) => (
            <Group key={g.code} group={g} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Toolkit;
